import {createAction} from '@reduxjs/toolkit';
import {
  SET_CATEGORIES,
  SET_CATEGORIES_PAGINATION,
} from '@crema/types/actions/Category.action';

export const SetCategories = createAction<any[]>(SET_CATEGORIES);
export const SetCategoriesPagination = createAction<{
  count: number;
  pages: number;
}>(SET_CATEGORIES_PAGINATION);
